import React, {useState} from 'react';
import { Card } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCog } from '@fortawesome/free-solid-svg-icons'
import UsersView from '../../views/Users/index.jsx';
import Modal from '../../components/Modal/index.jsx';
import CreateUser from '../../views/CreateUser/index.jsx';
import UpdateUser from '../../views/UpdateUser/index.jsx';
import Slide from '../../components/Slide';

export default function Users() {
  const [modal, setModal] = useState(false);
  const [userUpdateID, setUserUpdateID] = useState(0);
   const [userUpdateName, setUserUpdateName] = useState(0);
    const [userUpdateCodPatient, setUserUpdateCodPatient] = useState(0);
     const [userUpdateCPF, setUserUpdateCPF] = useState(0);
      const [userUpdateMotherName, setUserUpdateMotherName] = useState(0);
       const [userUpdateBirthday, setUserUpdateBirthday] = useState(0);
        const [userUpdateTel, setUserUpdateTel] = useState(0);
         const [userUpdateEmail, setUserUpdateEmail] = useState(0);
            const [userUpdateCategoria, setUserUpdateCategoria] = useState(0);
  const [modalUpdate, setModalUpdate] = useState(false);

  const openUpdateUser = (userID, Name, CodPatient, CPF, MotherName, Birthday, Tel, Email, Categoria) => {

    setUserUpdateID(userID)
    setUserUpdateName(Name)
    setUserUpdateCodPatient(CodPatient)
    setUserUpdateCPF(CPF)
    setUserUpdateMotherName(MotherName)
    setUserUpdateBirthday(Birthday)
    setUserUpdateTel(Tel)
    setUserUpdateEmail(Email)
    setUserUpdateCategoria(Categoria)
    setModalUpdate(true)
  }

  return (
    <div>
      
      <Slide title={<><FontAwesomeIcon icon={faUserCog} /> Usuários</>}/>

      <Card>        
        <UsersView openUpdateUser={openUpdateUser}/>
        
        <Modal title="Novo Usuário" size="lg" modal={modal} setModal={setModal} Content={CreateUser}/>
    <Modal
    title="Editar Usuário"
    size="lg"
    modal={modalUpdate}
    setModal={setModalUpdate}
    Content={() => (
      <UpdateUser 
        userID={userUpdateID}
        Name={userUpdateName}
        CodPatient={userUpdateCodPatient}
        CPF={userUpdateCPF}
        MotherName={userUpdateMotherName}
        Birthday={userUpdateBirthday}
        Tel={userUpdateTel}
        Email={userUpdateEmail}
        Categoria={userUpdateCategoria}
      />
    )}
  />

      </Card>
    </div>
  );
}
